// extracted by mini-css-extract-plugin
module.exports = {"logo":"app_logo__2UDV7","headerBg":"app_headerBg__awjnJ"};